import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { useRef } from 'react';
import { IMemberProps } from '../../../common/interface/props';
import Presenter from './Presenter';
import { axiosCustom } from '../../../common/common.function';
import { useNavigate, useSearchParams } from 'react-router-dom';

function Container({ solType }: IMemberProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const navigate = useNavigate(); // 히스토리 구하기
  const [searchParams] = useSearchParams(); // url param 가져오기

  const password: any = useRef(); //회원가입 전용, 비밀번호와 비밀번호 체크 일치여부 확인시 필요
  password.current = watch('password'); //비밀번호에 입력한 값
  // 쇼핑몰 로그인 정보 전송 함수
  async function onSubmit(data: any) {
    const { confirmPassword } = data;
    const userToken = searchParams.get('userToken');

    try {
      // 무한 로딩 화면 생성
      Swal.fire({
        title: `비밀번호 변경중...`,
        html: '플레이오토 비밀번호를 변경하는 중입니다.', // add html attribute if you want or remove
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      const resetPasswordResult = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/member/reset-password`, {
        password: confirmPassword,
        userToken: userToken,
      });

      await Swal.fire({
        title: '성공',
        html: `${resetPasswordResult.message}`,
        icon: 'success',
        confirmButtonText: '확인',
      });

      navigate(`/${solType.toLowerCase()}/member/login`); //해당 주소로 이동
    } catch (e: any) {
      Swal.fire({
        title: '실패',
        html: `${e.message}`,
        icon: 'error',
      });
    }
  }
  return (
    <>
      <Presenter
        useForm={{ register, handleSubmit, errors }} // react-hook-form 객체
        onSubmit={onSubmit} // submit handler
        inputPassword={password.current}
      />
    </>
  );
}

export default Container;
